import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const LoyaltyProgram = ({
  size,
  type,
  theme,
  className,
  dataTestId = "loyalty-program-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        d="M3.86 1.291c.449-.278 1.004-.354 1.596-.256C6.555 1.218 7.272 2 7.734 2.73c.111.175.212.356.305.536.092-.18.194-.36.305-.536.461-.73 1.179-1.512 2.278-1.695.592-.098 1.147-.022 1.595.256.455.282.728.729.82 1.226.105.56-.016 1.168-.328 1.743h1.122c.74 0 1.34.6 1.34 1.34v2.093a1.34 1.34 0 0 1-1.273 1.339v4.706c0 .74-.6 1.34-1.34 1.34h-9.04c-.74 0-1.34-.6-1.34-1.34V9.032A1.34 1.34 0 0 1 .908 7.693V5.6c0-.74.6-1.34 1.34-1.34h1.122c-.312-.575-.433-1.182-.329-1.743.093-.497.366-.944.82-1.226Zm7.18 2.97c.604-.59.74-1.175.68-1.5a.466.466 0 0 0-.21-.331c-.107-.067-.314-.132-.669-.073-.544.09-.985.489-1.365 1.09-.17.268-.31.545-.43.813h1.994Zm-4.438-.815c.17.269.309.546.43.814H5.038c-.605-.589-.74-1.174-.68-1.498a.466.466 0 0 1 .209-.332c.108-.067.315-.132.67-.073.544.09.985.489 1.365 1.09ZM8.71 9.033H7.368v4.705H8.71V9.033Zm1.34 0v4.705h2.509V9.033h-2.51Zm-6.532 0h2.51v4.705h-2.51V9.033ZM2.247 5.6H13.83v2.093H2.247V5.6Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </SVGIcon>
);
